/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  login,
  resendEmail,
  forgotpassword
} from "../../actions/auth/authAction";
import { googleLogin } from "../../actions/auth/authAction";
import LogInForm from "./LogInForm";
import Alert from "../../shared/components/Alert";
import VideoPlayer from "../../shared/components/VideoPlayer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, UncontrolledTooltip, Nav, NavItem } from "reactstrap";
import { NavLink as NavLinkStrap } from "reactstrap";

import {
  faFacebook,
  faTwitter,
  faYoutube,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import hero8 from "../../assets/images/hero-bg/hero-15.jpg";
import { openSocialLink } from "../../helpers";

class LogIn extends PureComponent {
  state = {
    isResendEmailOpen: false,
    email: null,
    loading: false,
    error: null,
    success: null,
    errorType: null
  };

  onFormSubmit = values => {
    this.setState({
      email: values.email
    });
    this.setState({ loading: true, error: null, errorType: null });
    this.props.login(values);
  };

  resetPassword = values => {
    this.setState({
      loading: true,
      error: null,
      success: null,
      errorType: null,
      redirectTo: "/dashboard"
    });
    this.props.forgotPassword({
      email: values.email,
      user_role: "user"
    });
  };

  onFormReset = () => {
    this.setState({ error: null, success: null, errorType: null });
  };

  handleResendEmail = e => {
    e.preventDefault();
    this.setState({ loading: true, error: null, errorType: null });
    if (this.state.email) {
      this.props.resendEmail(this.state.email);
    }
  };

  onSocialLogin = response => {
    this.setState({ loading: true, error: null, errorType: null }, () => {
      this.props.googleLogin(response.tokenObj.id_token);
    });
  };

  toggleResendEmail = e => {
    e.preventDefault();
    this.setState({ isResendEmailOpen: !this.state.isResendEmailOpen });
  };

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.history.push("/dashboard");
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const search = nextProps.history.location.search;
    let redirectTo = prevState.redirectTo || "/dashboard";
    if (search) {
      const searchParms = search.split("=");
      if (searchParms.length > 0 && searchParms[0] === "?redirectTo") {
        redirectTo = search.substr(search.indexOf("=") + 1);
      }
    }
    if (prevState.loading) {
      if (nextProps.auth.isAuthenticated) {
        nextProps.history.push(redirectTo);
        return { loading: false, redirectTo: redirectTo };
      } else if (nextProps.auth.loginSuccess === false) {
        return {
          loading: false,
          error: nextProps.auth.error,
          errorType: nextProps.auth.type,
          redirectTo: redirectTo
        };
      }
    }

    //  Resend Email

    if (nextProps.auth.resendEmailSuccess === true) {
      return { loading: false, success: nextProps.auth.message };
    } else if (nextProps.auth.resendEmailSuccess === false) {
      return { loading: false, error: nextProps.auth.error };
    }

    //  Forgot Password

    if (nextProps.auth.isForgotPasswordSuccess === true) {
      return { loading: false, success: nextProps.auth.message };
    } else if (nextProps.auth.isForgotPasswordSuccess === false) {
      return { loading: false, error: nextProps.auth.error };
    }
    return null;
  }

  openSocialLink = socialType => {
    switch (socialType) {
      case "twitter":
        window.open("https://twitter.com/BetterCapitalUS", "_blank");
        break;
      case "facebook":
      default:
        window.open("https://fb.com/bettercapital.us", "_blank");
        break;
    }
  };

  videoReady = () => {};
  render() {
    let alertContent;
    if (this.state.error) {
      alertContent = (
        <Alert color="danger" className="alert--bordered" icon>
          <React.Fragment>
            <p>{this.state.error}</p>
            {this.state.errorType === "email_not_activated" && (
              <div>
                <br />
                <a href="/dashboard" onClick={this.handleResendEmail}>
                  Resend verification email
                </a>
              </div>
            )}
          </React.Fragment>
        </Alert>
      );
    } else if (this.state.success) {
      alertContent = (
        <Alert color="success" className="alert--bordered" icon>
          <p>{this.state.success}</p>
        </Alert>
      );
    }

    return (
      <div className="app-wrapper login-screen min-vh-100 bg-white">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-inner-content-layout--main">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content">
                  <Row className="min-vh-100 no-gutters">
                    <Col lg="7" xl="6" className="d-flex align-items-center">
                      <Col md="10" lg="8" xl="8" className="mx-auto">
                        {alertContent}
                        <LogInForm
                          onSubmit={this.onFormSubmit}
                          onReset={this.onFormReset}
                          onResetPassword={this.resetPassword}
                          onSocialLogin={this.onSocialLogin}
                          loading={this.state.loading}
                        />
                      </Col>
                    </Col>
                    <Col lg="5" xl="6" className="d-flex">
                      <div className="hero-wrapper w-100 bg-composed-wrapper bg-premium-dark min-vh-lg-100">
                        <div className="flex-grow-1 w-100 d-flex align-items-center">
                          <div
                            className="bg-composed-wrapper--image opacity-5"
                            style={{ backgroundImage: "url(" + hero8 + ")" }}
                          />
                          <div className="bg-composed-wrapper--bg bg-second opacity-6" />
                          <div className="bg-composed-wrapper--bg bg-deep-blue opacity-2" />
                          <div className="bg-composed-wrapper--content text-center p-5">
                            <div className="text-white px-0 px-lg-2 px-xl-4">
                              <h1 className="display-3 mb-4 font-weight-bold">
                                Take control of your real estate investments
                              </h1>
                              <p className="display-4 mb-0 opacity-8">
                                BetterCapital.us is a great, easy way to keep
                                track of all your investments, whether they're
                                paying off or not.
                              </p>
                              <div className="divider mx-auto border-1 my-5 border-light opacity-2 rounded w-25" />
                              <VideoPlayer
                                url={
                                  "https://www.youtube.com/watch?v=TA-W___W7ac"
                                }
                                ctaBtnColor="success"
                                ctaBtnLabel="Intro"
                                ctaBtnTag="button"
                                className="px-5 font-size-sm font-weight-bold btn-animated-icon text-uppercase rounded shadow-none py-3 hover-scale-sm hover-scale-lg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="hero-footer pb-4">
                          <Nav pills className="nav-neutral-secondary">
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("facebook")}
                                className="font-size-lg text-white-50"
                                id="FacebookTooltipExample7"
                              >
                                <FontAwesomeIcon icon={faFacebook} />
                              </NavLinkStrap>
                              <UncontrolledTooltip
                                target="FacebookTooltipExample7"
                                container="body"
                              >
                                Facebook
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("twitter")}
                                className="font-size-lg text-white-50"
                                id="btnTwitterTooltip"
                              >
                                <FontAwesomeIcon icon={faTwitter} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnTwitterTooltip">
                                Twitter
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("youtube")}
                                className="font-size-lg text-white-50"
                                id="btnGoogleTooltip"
                              >
                                <FontAwesomeIcon icon={faYoutube} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnGoogleTooltip">
                                YouTube
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("instagram")}
                                className="font-size-lg text-white-50"
                                id="btnInstagramTooltip"
                              >
                                <FontAwesomeIcon icon={faInstagram} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnInstagramTooltip">
                                Instagram
                              </UncontrolledTooltip>
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.login
});

const mapDispatchToProps = dispatch => {
  return {
    login: userData => login(userData, dispatch),
    googleLogin: token => {
      googleLogin(token, dispatch);
    },
    resendEmail: email => {
      resendEmail(email, dispatch);
    },
    forgotPassword: userData => forgotpassword(userData, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogIn);
